// extracted by mini-css-extract-plugin
module.exports = {"grid":"SimilarDesignsSkeleton_grid__lzn7K"};